// extracted by mini-css-extract-plugin
export default {"BorderedCard":"BorderedCard_BorderedCard__10M8j"};